"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var router_2 = require("@angular/router");
var searchroute_service_1 = require("./../../../Services/searchroute.service");
var geolocation_service_1 = require("./../../../Services/geolocation.service");
var search_results_component_1 = require("./../../../Adv/search-results/search-results.component");
var WickedApiClient_1 = require("./../../../api/WickedApiClient");
var service_service_1 = require("./../../../Services/service.service");
var core_1 = require("@angular/core");
var environment_1 = require("../../../../environments/environment");
var ResultsComponent = /** @class */ (function (_super) {
    __extends(ResultsComponent, _super);
    function ResultsComponent(service, geolocationService, searchRouteService, advertisementClient, router, route) {
        var _this = _super.call(this, service, geolocationService, searchRouteService, advertisementClient, router, route) || this;
        _this.service = service;
        _this.geolocationService = geolocationService;
        _this.enableSubscription = false;
        _this.enableSubscription = service.enableSubscription;
        service.pageName = "Results";
        return _this;
    }
    ResultsComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        document.getElementById('scroll-view-content').scrollTop = 0;
    };
    ResultsComponent.prototype.openAdv = function (id) {
        this.service.route.navigate(["adv-detail/" + id]);
    };
    ResultsComponent.prototype.getAdvTitle = function (adv) {
        var tag = this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId ? "" : "[" + adv.categoryCode + "] ";
        return "" + tag + adv.title;
    };
    ResultsComponent.prototype.getImageFromCard = function (card) {
        if (card.images.length > 0) {
            var mainImage = card.images.filter(function (v) { return v.isMain == true; });
            if (mainImage.length > 0) {
                return environment_1.environment.apiBaseUrl + "/FileGet/" + mainImage[0].fileName + "/300x700";
            }
            else {
                return environment_1.environment.apiBaseUrl + "/FileGet/" + card.images[0].fileName + "/300x700";
            }
        }
        else {
            return '';
        }
    };
    ResultsComponent.prototype.showTip = function (e) {
        e.stopPropagation();
        e.target.getElementsByClassName("textTip")[0].style.opacity = "1";
        setTimeout(function () {
            e.target.getElementsByClassName("textTip")[0].style.opacity = "0";
        }, 2000);
    };
    ResultsComponent.prototype.pageChange = function (e) {
        document.getElementById('scroll-view-content').scrollTop = 0;
    };
    return ResultsComponent;
}(search_results_component_1.SearchResultsComponent));
exports.ResultsComponent = ResultsComponent;
